import React from 'react';
import { Globe } from 'lucide-react';

export const LANGUAGES = [
  { code: 'en-US', name: 'English (US)', flag: 'US' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', flag: 'BR' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)', flag: 'PT' },
  { code: 'es-ES', name: 'Spanish (Spain)', flag: 'ES' },
  { code: 'fr-FR', name: 'French (France)', flag: 'FR' },
  { code: 'de-DE', name: 'German (Germany)', flag: 'DE' },
  { code: 'it-IT', name: 'Italian (Italy)', flag: 'IT' },
  { code: 'nl-NL', name: 'Dutch (Netherlands)', flag: 'NL' },
  { code: 'ru-RU', name: 'Russian (Russia)', flag: 'RU' },
  { code: 'bg-BG', name: 'Bulgarian (Bulgaria)', flag: 'BG' }
];

const LanguageSelector = ({ selectedLanguage, onLanguageChange, disabled = false }) => {
  return (
    <div className={`mb-4 bg-green-50 p-3 rounded-lg border border-green-200 flex items-center gap-2 ${disabled ? 'opacity-60' : ''}`}>
      <Globe className="w-5 h-5 text-green-600" />
      <select
        value={selectedLanguage}
        onChange={(e) => !disabled && onLanguageChange(e.target.value)}
        className={`p-2 border border-green-300 rounded bg-white flex-grow ${disabled ? 'cursor-not-allowed bg-gray-100' : ''}`}
        disabled={disabled}
      >
        {LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag} {language.name}
          </option>
        ))}
      </select>
      <span className="text-xs text-green-700">
        Content will be generated in this language
      </span>
    </div>
  );
};

export default LanguageSelector;
